import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  serviceIcon: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
  contentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10,
  },
  title: {
    height: 12,
    marginLeft: 28,
    marginBottom: 10,
  },
  subtitle: {
    height: 12,
    marginLeft: 28,
  },
  description: {
    marginBottom: 9,
    marginLeft: 68,
    width: '80%',
  },
  descriptionContainer: {
    marginTop: 26,
    marginBottom: 20,
  },
})
